import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'dropdownTextLimiter'
})
export class DropdownTextLimiterPipe implements PipeTransform {

  transform(value: unknown, ...args: any[]): unknown {
    console.log(args);
    if((args[1].length - 1) == args[0].length) {
      return 'All'
    }
    if(args[0].length > 1) {
      return args[0][0] + ', + '+(args[0].length-1)+' More'
    }
    return args[0];
  }

}
